<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>{{$t('extracurriculares.clothes.page_title')}}</v-toolbar-title>
            <v-divider
                class="mx-2"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">{{$t('extracurriculares.clothes.new_type')}}</v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span v-show="!editingClothes" class="headline">{{$t('extracurriculares.clothes.new_type')}}</span>
                        <span v-show="editingClothes" class="headline">{{$t('extracurriculares.clothes.edit_type')}}</span>
                    </v-card-title>

                    <v-card-text>

                        <text-input
                            :form="form"
                            :label="$t('extracurriculares.clothes.form.name')"
                            :v-errors="errors"
                            :value.sync="form.name"
                            name="name"
                            v-validate="'required'"
                        ></text-input>

                        <select-multiple-input
                          :form="form"
                          :items="clothes_sizes"
                          :label="$t('extracurriculares.clothes.form.sizes')"
                          :v-errors="errors"
                          :value.sync="form.sizes"
                          name="sizes"
                        ></select-multiple-input>

                        <div class="upload">
                          <ul>
                            <li v-for="(file) in files" :key="file.id">
                              <span>{{file.name}}</span> -
                              <span>{{file.size}}</span>
                              &nbsp;&nbsp;&nbsp;
                              <span>
                                <v-tooltip top>
                                  <v-icon
                                    small
                                    class="mr-2"
                                    @click.prevent="$refs.upload.remove(file)"
                                    slot="activator"
                                  >
                                    delete
                                  </v-icon>
                                  <span>{{$t('extracurriculares.clothes.delete')}}</span>
                                </v-tooltip>
                              </span>
                            </li>
                          </ul>
                          <div class="example-btn">
                            <file-upload
                              class="mb-2 v-btn theme--dark primary"
                              extensions="gif,jpg,jpeg,png,webp"
                              accept="image/png,image/gif,image/jpeg,image/webp"
                              :multiple="true"
                              :size="1024 * 1024 * 10"
                              v-model="files"
                              @input-filter="inputFilter"
                              @input-file="inputFile"
                              ref="upload">
                              <i class="fa fa-plus"></i>
                              {{$t('extracurriculares.clothes.form.select_files')}}
                            </file-upload>

                          </div>
                        </div>

                        <check-input
                          name="status"
                          :form="form"
                          :label="$t('extracurriculares.clothes.form.status')"
                          :value.sync="form.status"
                          :color="'primary'"
                          :v-errors="errors"
                        >
                        </check-input>

                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="close">{{$t('extracurriculares.clothes.form.cancel')}}</v-btn>
                        <v-btn v-if="!editingClothes" color="blue darken-1" flat @click="saveClothes">{{$t('extracurriculares.clothes.form.save')}}</v-btn>
                        <v-btn v-else color="blue darken-1" flat @click="updateCourseType">{{$t('extracurriculares.clothes.form.update')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>
        <v-data-table
            :headers="headers"
            :items="clothes"
            :loading="loadingTable"
            class="elevation-1"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">{{ getClotheSizes(props.item.sizes) }}</td>
                <td class="text-xs-center">
                  <v-checkbox
                    :key="props.item.id"
                    :name="`check_${props.item.id}`"
                    :input-value="props.item.status"
                    @change="handleClothesStatus(props.item.id, props.item.status)"
                    color="primary"
                    class="center"
                  ></v-checkbox>
                </td>
                <td>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="clothesPictures(props.item.id)"
                      slot="activator"
                    >
                      photo_library
                    </v-icon>
                    <span>{{$t('extracurriculares.clothes.watch_pictures')}}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="editClothes(props.item.id)"
                      slot="activator"
                    >
                      edit
                    </v-icon>
                    <span>{{$t('extracurriculares.clothes.edit')}}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="deleteClothes(props.item.id)"
                      slot="activator"
                    >
                      delete
                    </v-icon>
                    <span>{{$t('extracurriculares.clothes.delete')}}</span>
                  </v-tooltip>
                </td>
            </template>
        </v-data-table>
        <v-dialog v-model="imagesDialog" max-width="600px">
          <template>
            <v-layout>
              <v-flex xs12>
                <v-card>
                  <v-container grid-list-sm fluid>
                    <v-layout row wrap>
                      <v-flex
                        v-for="(file, index) in clothes_files"
                        :key="index"
                        xs4
                        d-flex
                      >
                        <v-card>
                          <v-img
                            :src="file.file_url"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            height="180px"
                            width="180px"
                          >
                            <template v-slot:placeholder>
                              <v-layout
                                fill-height
                                align-center
                                justify-center
                                ma-0
                              >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-layout>
                            </template>
                          </v-img>
                          <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn @click="deleteClotheFile(file.id)" icon>
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-card-actions>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </template>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import Form from 'vform';
import FileUpload from 'vue-upload-component'
export default {
  name: 'enrollments-show-view',
  components: {
    FileUpload,
  },
  data() {
    return {
      headers: [
        { text: this.$t('extracurriculares.clothes.form.name'), align: 'center', value: 'name' },
        { text: this.$t('extracurriculares.clothes.form.sizes'), align: 'center', value: 'status' },
        { text: this.$t('extracurriculares.clothes.form.status'), align: 'center', value: 'status' },
        { text: this.$t('extracurriculares.clothes.form.actions'), align: 'left', value: 'start_date', sortable: false }
      ],
      clothes: [],
      clothes_sizes: [],
      editedIndex: -1,
      isLoading: false,
      loadingTable: false,
      dialog: false,
      form: new Form({
        name: '',
        sizes: [],
        status: true
      }),
      files: [],
      showSucessMessage: false,
      editingClothes: false,
      clothes_files: [],
      imagesDialog: false
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created() {
    this.getClothes()
  },
  methods: {
    async getClothes() {
      this.loadingTable = true;
      const { data } = await axios.get('/api/extracurriculares/manage/clothes')
      this.clothes = data;
      this.loadingTable = false;

      const sizes = await axios.get('/api/extracurriculares/manage/clothes_sizes')
      const activeSizes = sizes.data
        .filter(size => size.status === true || size.status === 1)
        .map(size => this.clothes_sizes.push({ value: size.id, text: size.name }));

    },
    close() {
      this.form.clear();
      this.form.reset();
      this.form = new Form({
        name: '',
        sizes: [],
        status: true
      })
      this.editingClothes = false
      this.dialog = false
    },
    async saveClothes() {

      if (await this.formHasErrors()) return

      const result = await this.form.post('/api/extracurriculares/manage/clothes', this.form)

      if (result.status === 200) {
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('extracurriculares.clothes.messages.saved_ok'),
          modal: false
        })
        this.uploadPictures(result.data.clothe_id);
      }

      this.close()
    },
    editClothes(id_type) {
      const clothesToEdit = this.clothes.filter(clothes => clothes.id === id_type)[0];
      this.editingClothes = true;
      this.dialog = true;
      let sizes = [];
      clothesToEdit.sizes.forEach(size => {
        sizes.push(size.size_id);
      })
      this.form = new Form({
        name: clothesToEdit.name,
        status: clothesToEdit.status,
        sizes,
        id: clothesToEdit.id
      });

    },
    deleteClothes(id_type) {
      axios.delete(`/api/extracurriculares/manage/clothes/${id_type}`)
        .then(resp => {
          if (resp.status === 200) {
            this.clothes = this.clothes
              .filter(clothes => clothes.id !== id_type);
          }
        })
        .catch(error => console.log(error));
    },
    updateCourseType() {

      this.form.put('/api/extracurriculares/manage/clothes')
        .then(resp => {
          if (resp.status === 200) {
            this.uploadPictures(resp.data.clothe_id);
            this.dialog = false;
            this.editingClothes = false;
            this.form = new Form({
              name: '',
              sizes: [],
              status: true
            })
          }
        })
        .catch(error => console.log(error));
    },
    handleClothesStatus(id_type, status) {
      axios.put('/api/extracurriculares/manage/clothes', { id: id_type, status: !status })
        .then(resp => {
          if (resp.status === 200) {
            this.clothes = this.clothes.map(type => {
              if (type.id === id_type) {
                type.status = !status;
              }
              return type;
            })
          }
        })
    },
    getClotheSizes(sizes) {
      let sizesToShow = [];
      sizes.forEach(size => {
        sizesToShow.push(size.size.name)
      });
      return sizesToShow.join(', ')
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log('add', newFile)
      }
      if (newFile && oldFile) {
        // update
        console.log('update', newFile)
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }
    },
    uploadPictures(id) {
      let formData = new FormData();
      let fileData;
      this.files.forEach((file, index) => {
        fileData = this.$refs.upload.get(file.id);
        formData.append(`file_${index}`, fileData.file);
      });
      formData.append('clothe_id', id);
      axios.post(`/api/extracurriculares/manage/clothes/files`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      .then(resp => {
        if (resp.status === 200) {
          this.$store.dispatch('responseMessage', {
            type: 'success',
            text: this.$t('extracurriculares.clothes.messages.files_saved'),
            modal: false
          })
          this.$refs.upload.clear();
          this.getClothes()
        }
      })
      .catch(error => console.log(error));
    },
    clothesPictures(id) {
      this.imagesDialog = true;
      this.clothes_files = this.clothes
        .filter(clothe => clothe.id === id)
        .map(clothe => clothe.files)[0];
    },
    deleteClotheFile(file_id) {
      axios.delete(`/api/extracurriculares/manage/clothes/file/${file_id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.clothes_files = this.clothes_files.filter(file => file.id !== file_id)
          }
        })
        .catch(error => console.log(error))
    }
  }
}
</script>
<style>
.center {
  text-align: center;
  vertical-align: middle;
  justify-content: center;
  align-content: center;
  align-items: center;
}
span.v-btn {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/manage_columbus/clothes.vue